module.exports = __webpack_public_path__ + "p5_img1.jpg?bf39e166cda6bd231a3d01997c1f7604";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img1.jpg
// module id = 114
// module chunks = 0